/**
 * @desc 修改全局或基地设置
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.ModifyTheGlobalOrBaseParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/setting/detail/update',
    data,
  });
}

export function mock(
  data: defs.ModifyTheGlobalOrBaseParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/setting/detail/update',
    data,
  });
}
